import { render, staticRenderFns } from "./invoice_tab.vue?vue&type=template&id=defd9b72&scoped=true&"
import script from "./invoice_tab.vue?vue&type=script&lang=js&"
export * from "./invoice_tab.vue?vue&type=script&lang=js&"
import style0 from "./invoice_tab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./invoice_tab.vue?vue&type=style&index=1&id=defd9b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defd9b72",
  null
  
)

export default component.exports